import { Link } from 'react-router-dom';
import { tools, categories } from './toolsData';
import type { ToolDefinition } from './toolsData';
import { TourButton } from '../../components/TourGuide';
import { TOOLS_HUB_TOUR } from '../../components/TourGuide/tourSteps';
import './ToolsHub.css';

function ToolCard({ tool }: { tool: ToolDefinition }) {
  const isLive = tool.status === 'live';
  const isProjectionFeature = tool.status === 'projection-feature';
  const cardContent = (
    <>
      <div className="tools-card-header">
        <span className="tools-card-icon">{tool.icon}</span>
        <div className="tools-card-badges">
          <span className={`tools-card-tier tools-card-tier--${tool.tier.toLowerCase()}`}>
            {tool.tier}
          </span>
          {isLive && <span className="tools-card-live-badge">Live</span>}
          {isProjectionFeature && (
            <span className="tools-card-projection-badge">Plan feature</span>
          )}
        </div>
      </div>
      <h3 className="tools-card-name">{tool.name}</h3>
      <p className="tools-card-description">{tool.description}</p>
    </>
  );

  if (isLive) {
    return (
      <Link to={`/tools/${tool.slug}`} className="tools-card tools-card--live">
        {cardContent}
      </Link>
    );
  }

  if (isProjectionFeature) {
    return (
      <Link to={`/tools/${tool.slug}`} className="tools-card tools-card--projection-feature">
        {cardContent}
      </Link>
    );
  }

  return (
    <div className="tools-card tools-card--coming-soon">
      {cardContent}
    </div>
  );
}

export function ToolsHub() {
  return (
    <div className="tools-hub">
      <div className="tools-hub-hero">
        <div className="step-header-row">
          <h1 className="tools-hub-title">Tools &amp; Calculators</h1>
          <TourButton tour={TOOLS_HUB_TOUR} variant="text" />
        </div>
        <p className="tools-hub-subtitle">
          Most people have no idea if they're saving enough. These tools give you a clear answer in minutes.
        </p>
      </div>

      {categories.map((category) => {
        const categoryTools = tools.filter((t) => t.category === category);
        return (
          <section key={category} className="tools-hub-section">
            <h2 className="tools-hub-section-title">{category}</h2>
            <div className="tools-hub-grid">
              {categoryTools.map((tool) => (
                <ToolCard key={tool.slug} tool={tool} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
